var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"go",staticClass:"go"},[_vm._m(0),_c('div',{staticClass:"circle-2"}),_c('div',{staticClass:"circle-3"}),_c('div',{staticClass:"circle-4"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-1"},[_c('h1',[_vm._v("GO!")])])
}]

export { render, staticRenderFns }